export default __webpack_public_path__ + "static/media/p3.1869c8e7.jpg";